import React, { useEffect, useState } from 'react';
import { isAuthenticated } from '../apiCallsHelper/authapicalls';
import TaskForm from '../task/TaskForm';
import { deleteTask, editTask, editTaskStatus, getTasks } from '../apiCallsHelper/taskapicalls';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile, faFileSignature, faHandPointLeft, faHandPointUp, faXmark } from '@fortawesome/free-solid-svg-icons';
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Checkbox from '../utils/Checkbox';
import ModalForm from '../utils/ModalForm';
import ModalAlert from '../utils/ModalAlert';
import addTaskImg from "../images/add-task.png"
import chooseTodoImg from "../images/choose-todo.png"
import "../styles.css"



const TaskList = ({ findTodo, activeTodo, isTaskAdded, isTasksAvailable, setIsTasksAvailable, isTodoEdited }) => {

  const { user, token } = isAuthenticated();

  const [taskItems, setTaskItems] = useState([]);
  const [isTaskSubmitted, setIsTaskSubmitted] = useState(false);
  const [todoTitle, setTodoTitle] = useState("");
  const [isTaskCompleted, setIsTaskCompleted] = useState(false);
  const [isTaskChecked, setIsTaskChecked] = useState(false);
  const [isEdited, setIsEdited] = useState(false);
  const [isOpenModalForm, setIsOpenModalForm] = useState(false);
  const [editTaskId, setEditTaskId] = useState(null);
  const [modalInput, setModalInput] = useState("");
  const [isOpenModalAlert, setIsOpenModalAlert] = useState(false);





  //---------- Fetch Tasks ----------

  const fetchTasks = () => {
    if (findTodo != null) {
      getTasks(findTodo, user._id, token)
        .then(data => {
          if (data.error) {
          }
          else {
            setTodoTitle(data.title);
            setTaskItems(data.tasks)
            if(data.tasks.length > 0) {
              setIsTasksAvailable(true);
            }
            else {
              toast.info(data.message, {
                style: { width: "240px", marginLeft: "70px" }
              })
              setIsTasksAvailable(false);
            }
          }
        })
    }
  }





  //---------- Delete Task --------------

  const handleDeleteTask = (todoId, taskId) => {
    deleteTask(todoId, taskId, user._id, token).then(data => {
      if (data.error) {
        toast.error(data.error);
      }
      else {
        setTaskItems(data.todo.tasks);
        toast.success(data.message, {
          style: { width: "200px", marginLeft: "120px", }
        })


        if (data.todo.tasks.length === 0) {
          setIsTasksAvailable(false);
        }
      }
    })
  }





  //---------- Update Task Completion Status - checkbox --------------

  const handleTaskCheckStatus = (e, todoId, taskId) => {
    const currentTaskStatus = e.target.checked;
    editTaskStatus(todoId, taskId, user._id, token, { taskStatus: currentTaskStatus }).then(data => {
      if (data.error) {
        toast.error(data.error, {
          style: { width: "240px", marginLeft: "70px" }
        })
      }
      else {
        setIsTaskCompleted(!isTaskCompleted)
        setIsTaskChecked(!isTaskChecked)
        toast.success(data.message, {
          style: { width: "240px", marginLeft: "120px", }
        });
      }
    })
  }




  //---------- Update Task Completion Status - strikethrough --------------
  const handleTaskStatus = (todoId, taskId, taskStatus) => {
    editTaskStatus(todoId, taskId, user._id, token, { taskStatus: !taskStatus }).then(data => {
      if (data.error) {
        toast.error(data.error, {
          style: { width: "240px", marginLeft: "70px" }
        });
      }
      else {
        setIsTaskCompleted(!isTaskCompleted);
        setIsTaskChecked(!isTaskChecked);
        toast.success(data.message, {
          style: { width: "240px", marginLeft: "120px", }
        })
      }
    })
  }






  //---------- Edit Task Modal start ----------------------

  const handleTaskEditOpenModal = (taskId, task, taskStatus) => {
    if (taskStatus) {
      handleOpenModalAlert();
    }
    else {
      setEditTaskId(taskId);
      setIsOpenModalForm(true);
      setModalInput(task);
    }
  };


  const handleCloseModalForm = () => {
    setIsOpenModalForm(false);
  };


  const handleSubmitModalClick = () => {
    if (modalInput.length > 0) {
      handleCloseModalForm();
      editTask(findTodo, editTaskId, user._id, token, { task: modalInput }).then(data => {
        if (data.error) {
          setModalInput("");
          toast.error(data.error, {
            style: { width: "240px", marginLeft: "70px" }
          })
        }
        else {
          setIsEdited(!isEdited)
          setModalInput("");
          toast.success(data.message, {
            style: { width: "200px", marginLeft: "120px", }
          })
        }
      })
    }
  };


  const handleCancelModalClick = () => {
    handleCloseModalForm();
  };



  const handleOpenModalAlert = () => {
    setIsOpenModalAlert(true);
  };



  const handleCloseModalAlert = () => {
    setIsOpenModalAlert(false);
  };

  //---------- Edit Task Modal end --------------





  
  useEffect(() => {
         fetchTasks();
  }, [activeTodo, isTaskAdded, isTaskSubmitted, isTaskCompleted, isEdited, isTodoEdited]);





  return (
    <>
      <div>
        {activeTodo ? (
          <div className='flex  xs:flex  sm:flex   md:flex    smLaptop:flex smLaptop:flex-col smLaptop:w-[260px]    lg:w-[265px] xl:w-full'>
            <div className='w-2/3  xs:w-2/3  mobSm:w-2/3 sm:w-2/3 mobLg:w-[40%]  md:w-1/2   smLaptop:w-full   xl:w-full'>
              <TaskForm findTodo={findTodo} isTaskSubmitted={isTaskSubmitted} setIsTaskSubmitted={setIsTaskSubmitted} setIsTasksAvailable={setIsTasksAvailable} setTodoTitle={setTodoTitle} />
            </div>
            {isTasksAvailable ? (
              <div className='w-2/1   xs:w-2/1  mobSm:w-2/1 sm:w-2/1  mobLg:w-[60%]   md:w-1/2    smLaptop:w-full   lg:w-full xl:w-full'>
                <div className="container mx-auto flex">
                  <div className='w-full'>
                    <div className="flex flex-col text-center w-full  mb-4">
                      <h1 className="break-all  mt-2  xs:mt-8 xs:text-lg   sm:mt-8 sm:text-xl   md:mt-4 md:mb-2 md:l:text-2xl   smLaptop:w-full smLaptop:mt-8 smLaptop:mb-2 smLaptop:text-2xl   lg:w-full lg:mt-8 lg:mb-2 lg:text-2xl    xl:w-full xl:mt-8 xl:mb-2 xl:text-2xl    text-center font-medium title-font text-[#356496]">
                        <FontAwesomeIcon icon={faFile} color='#ebbf49' /> Tasks of '{todoTitle.length > 55 ? `${todoTitle.substring(0, 55)}...` : todoTitle}'
                      </h1>
                    </div>
                    <div className="w-[150px] h-[350px] mt-2   xs:w-[200px] xs:h-[340px] xs:mt-2    mobSm:w-[230px] mobSm:h-[390px] mobSm:mt-2     sm:w-[250px] sm:h-[390px] sm:mt-2    mobLg:w-[370px] mobLg:h-[390px] mobLg:mt-2   md:w-[364px] md:h-[390px] md:mt-4    smLaptop:w-[255px] smLaptop:h-[471px] smLaptop:mt-4    lg:w-[260px] lg:h-[455px] lg:mt-4     xl:w-[400px] xl:h-[455px] xl:mx-4 xl:mt-4 container">
                      <table className="w-[150px] h-[350px]   xs:w-[200px] xs:h-[280px]   mobSm:w-[230px] mobSm:h-[350px]  sm:w-[245px] sm:h-[360px]     mobLg:w-[370px] mobLg:h-[360px]    md:w-[362px] md:h-[350px]  smLaptop:w-[255px] smLaptop:h-[455px] smLaptop:text-md      lg:w-[260px] lg:h-[455px] lg:text-[15px]    xl:w-[400px] xl:h-[455px] xl:text-[16px] xl:leading-[24px]  text-left">
                        <thead className="w-[150px]   xs:w-[200px]  mobSm:w-[230px]   sm:w-[245px] mobLg:w-[370px]   md:w-[360px]   smLaptop:w-[255px]    lg:w-[260px] xl:w-[399px] flex bg-[#c1cae3] text-white ">
                          <tr className="flex w-full   smLaptop:mb-4">
                            <th className="py-4   xs:px-2 xs:py-4 xs:w-[60px]">Status</th>
                            <th className="py-4  xs:pl-4 xs:py-4 xs:w-[230px]">Task</th>
                            <th className=" py-4   xs:py-4 xs:w-[60px]">Edit</th>
                            <th className=" py-4  xs:hidden">Del</th>
                            <th className=" py-4  hidden   xs:block xs:py-4 xs:w-[60px]">Delete</th>
                          </tr>
                        </thead>
                        <tbody className=" w-[150px] h-[228px]   xs:w-[200px] xs:h-[228px] mobSm:w-[230px] mobSm:h-[287px]   sm:w-[245px] sm:h-[288px] mobLg:w-[370px]   md:w-[360px] md:h-[288px]   smLaptop:w-[255px] smLaptop:h-[401px]    lg:w-[260px] lg:h-[398px]    xl:w-[400px] xl:h-[400px]   flex flex-col   overflow-y-auto ">
                          {taskItems && taskItems.map((taskItem, index) => {
                            const { _id, task, taskStatus } = taskItem;
                            const words = task.split(' ');
                            const shouldBreakWords = words.some((word) => word.length > 20);
                            return (
                              <tr key={_id} className={index % 2 === 0 ? 'border-b-2 border-l-2 border-r-2 border-[#ebeef7]' : 'bg-[#ebeef7]'}>
                                <td className=" py-4  xs:pl-2 xs:py-4    lg:pl-2 lg:w-[30px]    xl:py-4 xl:pl-4 xl:w-[60px] text-center ">
                                  <div data-tooltip-id="task-status-tooltip" data-tooltip-content="Task Completion Status">
                                    <Checkbox checkboxContainerClass="task-checkbox-container" checkmarkClass="task-checkmark" checked={taskStatus} onChange={(e) => handleTaskCheckStatus(e, findTodo, _id)} />
                                  </div>
                                  <Tooltip id="task-status-tooltip" place="bottom" style={{ backgroundColor: "#e1e7f0", color: "#1f4578", padding: "2px 5px", fontSize: "12px" }} />
                                </td>
                                <td onClick={(e) => handleTaskStatus(findTodo, _id, taskStatus)} className={` w-[210px] pr-2 py-4 text-md text-gray-900 cursor-pointer  border-[#c1cae3] ${taskStatus ? "line-through" : ""}   ${shouldBreakWords ? 'break-all' : ""} `}>
                                  {task}
                                </td>
                                <td className="py-4    xs:w-[60px] text-center  ">
                                  <button onClick={() => handleTaskEditOpenModal(_id, task, taskStatus)}>
                                    <FontAwesomeIcon icon={faFileSignature} color='#5082e8' />
                                  </button>
                                </td>
                                <td className="py-4    xs:w-[60px] text-center   border-[#c1cae3]">
                                  <button onClick={() => handleDeleteTask(findTodo, _id)}>
                                    <FontAwesomeIcon icon={faXmark} color='#e33c30' className='text-xl' />
                                  </button>
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>


                    {editTaskId ? (
                      <ModalForm
                        isOpenModalForm={isOpenModalForm}
                        onCloseModal={handleCloseModalForm}
                        onSubmitModalClick={handleSubmitModalClick}
                        submitText="Add task"
                        onCancelModalClick={handleCancelModalClick}
                        modalFormMessage="Please enter task"
                        modalInput={modalInput}
                        setModalInput={setModalInput}
                      />
                    ) : null}


                    {isOpenModalAlert ? (
                      <ModalAlert
                        isOpenModalAlert={isOpenModalAlert}
                        handleCloseModalAlert={handleCloseModalAlert}
                        modalAlertMessage="Sorry, you cannot edit a completed Task."
                        modalAlertSubMessage="If you still want to edit it, please uncheck the status and try again."
                      />
                    ) : null}

                  </div>
                </div>
              </div>
            ) : (
              <div className='md:w-[372px] smLaptop:w-[258px] smLaptop:mt-[80px]   lg:w-[250px] lg:mt-[100px]     xl:w-[420px] xl:h-[535px] xl:mt-20  text-center grid items-centertext-[#536491] text-xl  font-bold  border-gray-300'>
                <img src={addTaskImg} alt="add task" className=' xs:h-[290px]  sm:h-[330px]    md:h-[360px]   smLaptop:h-[350px]  lg:h-[300px] xl:h-[380px]' />
                <div className='text-[#536491]   smLaptop:mt-14  lg:mt-10  xl:mt-2'>Please add task!</div>
              </div>)
            }

          </div>
        ) : (
          <div className='flex  flex-row w-[160px]  xs:flex-row xs:w-[240px]  sm:flex-row sm:w-[360px]  mobLg:w-[470px] md:flex-row md:h-[350px] md:w-[740px]   smLaptop:flex-col smLaptop:w-[260px] smLaptop:h-[800px]   lg:w-[265px] lg:h-[820px] lg:flex lg:flex-col   xl:w-[420px] xl:text-xl xl:h-[820px] text-[#536491]    text-center font-bold   '>
            <div>
              <div className='mt-10 hidden   smLaptop:flex smLaptop:flex-col smLaptop:mt-[120px]  lg:text-[20px] xl:mt-[120px]   xl:text-[24px] xl:mt-[120px] px-6  '> Tasks </div>
              <div className='mt-10  xs:mt-4  sm:mt-20 '>
                <FontAwesomeIcon icon={faHandPointUp} size='xl' className='   md:hidden ' />
                <div className='mt-2  text-xs  xs:mt-4 xs:text-xs xs:px-2 xs:mx-2    sm:mt-4 sm:text-[12px] sm:px-2 sm:mx-2   mobLg:text-[14px]  md:hidden border border-gray-300 rounded'>Click on a Todo <span className='  smLaptop:hidden '>above</span> to display its corresponding subtasks</div>
              </div>
            </div>
            <img src={chooseTodoImg} alt="click on todo" className='   md:h-[300px] md:w-[300px] md:my-4    smLaptop:w-[260px] smLaptop:mt-[120px]   lg:w-full lg:h-[340px] lg:my-0 lg:mt-[110px]   xl:h-[400px] xl:mt-[70px] ' />
            <div className='  hidden   md:flex   md:mt-[100px]     lg:text-[15px] lg:px-6 lg:mt-[20px]  smLaptop:mt-[15px]  xl:text-[20px] '>Click on a Todo to display its corresponding subtasks</div>
            <FontAwesomeIcon icon={faHandPointLeft} size='xl' className='   hidden  smLaptop:flex smLaptop:mt-10 smLaptop:ml-[120px]  lg:flex  lg:mt-10 lg:ml-[200px] lg:hover:ml-0 ' />
            <FontAwesomeIcon icon={faHandPointUp} size='xl' className=' hidden md:flex md:mt-[100px] md:mx-8    smLaptop:hidden   lg:hidden ' />
          </div>
        )
        }

      </div>

    </>

  )

}






export default TaskList;